import { Component, Input } from '@angular/core';

@Component({
    selector: 'router-tab',
    templateUrl: './router-tab.component.html',
    styleUrls: ['router-tab.component.scss'],
    standalone: false
})
export class RouterTabComponent {
    @Input()
    public route: string;

    @Input()
    public queryParams: any;
}